<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/TBOX3/TBOX3.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">第三代5G车载通信单元（经济版 ）</div>
                <div class="detail-banner-desc">
                    支持多模多频GNSS，实现亚米级定位；<br />
                    网络下行速率最高达224Mbps、上行速率达120Mbps；集成BLE6.0+UWB，支持数字钥匙功能，定位精度分米级；<br />
                    提供便利服务：30+远程控制和数据上报功能, 为用户带来便利，同时提升原始设备制造商（OEMs）的运营效率；实现ECALL、IBCall为车主及乘客安全提供保障；<br />
                    创新承诺：T-Box系列体现了我们对先进连接技术、安全保障及以用户为中心的解决方案的不懈追求，助力实现更智能、更安全的出行。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            网络：支持4/5G 通信,最大通信速率：226 M (DL)/ 120M(UL) bps<br />
                        </div>
                        <div>
                            标准：支持3GPP Rel-17 Redcap<br />
                        </div>
                        <div>
                            模组：集成多模多频导航模组<br />
                        </div>
                        <div>
                            通讯：车用以太网总线架构，以太网支持DOIP，SOMEIP协议，支持1000 BASE T1（兼容100 BASE T1）<br />
                        </div>
                        <div>
                            FOTA
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX3/TBOX3-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Dual core ARM Cortex-A55</div>
                                    <div class="k">CPU core</div>
                                </div>

                                
                                <div class="spec-item">
                                    <div class="v">3.2K DMIPS</div>
                                    <div class="k">Computing Power</div>
                                </div>
                                <div class="spec-item spec-item-two">
                                    <div class="v">up to 700 MHz</div>
                                    <div class="k">CPU frequency</div>
                                </div>
                                
                                
                                <div class="spec-item">
                                    <div class="v">100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Sub-M</div>
                                    <div class="k">定位精度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">14nm</div>
                                    <div class="k">制程</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Up to 226/ 120M bps</div>
                                    <div class="k">DL/UL Data rate</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">4Gb LPDDR4X+4Gb Nand Flash</div>
                                    <div class="k">存储器</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '第三代5G车载通信单元（经济版 ） - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/TBOX3.html'
};

import { createApp } from 'vue';
import App from './TBOX3.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./TBOX3.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
